import evidence from '../../../docs/efficiency-homepage-evidence-2026-10-28.json';

export const savingsEvidence = evidence;
export const DEFAULT_ILLUSTRATIVE_SPEND = 100;
export type SavingsBenchmark = keyof typeof evidence.benchmarks;
export const observedCostRatio = evidence.benchmarks.model.afterMicroUsd / evidence.benchmarks.model.beforeMicroUsd;
export function benchmarkRatio(kind: SavingsBenchmark) {
  const b = evidence.benchmarks[kind];
  return b.afterMicroUsd / b.beforeMicroUsd;
}

/** A scenario at the lab's ratio, never a prediction about a learner. */
export function savingsScenario(monthlyUSD: number, kind: SavingsBenchmark = 'model') {
  const before = Number.isFinite(monthlyUSD) ? Math.min(10_000, Math.max(0, monthlyUSD)) : 0;
  const after = before * benchmarkRatio(kind);
  return { before, after, saved: before - after };
}
